import clsx from 'clsx'
import { FormButton } from '../Form'
import { PopupClose } from '../Icon/PopupClose'
import PopupBody from './PopupBody'
import PopupFrame from './PopupFrame'
import PopupTitle from './PopupTitle'

const ModalNotAvailable = ({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean
  setIsOpen: () => void
}) => {
  return (
    <PopupFrame
      closeText={'đóng'}
      open={isOpen}
      onClose={setIsOpen}
      className='w-[380px] max-w-[528px] bg-white-400'
    >
      <PopupTitle className=''>
        {
          <div
            onClick={setIsOpen}
            className='absolute right-[12px] top-[40%] flex translate-y-[-40%] cursor-pointer items-center gap-1'
          >
            <PopupClose className='text-dark-400' />
          </div>
        }
      </PopupTitle>
      <PopupBody>
        <div className='listLocation flex h-full flex-col items-center justify-center overflow-scroll border-grey-100 px-4 pb-5 scrollbar-hide'>
          <p className='mb-1 text-center text-base text-dark-400'>
            Sản phẩm đặt trước không áp dụng cho địa chỉ của bạn. Giỏ hàng sẽ
            được cập nhật lại!
          </p>
          <FormButton
            onClick={setIsOpen}
            className={clsx(
              'disabled:text-[rgb(0 0 0 / 25%)] mt-2 h-[40px] w-[200px] rounded bg-red text-fieldInput font-bold text-white-400 disabled:outline-none'
            )}
          >
            Xác nhận
          </FormButton>
        </div>
      </PopupBody>
    </PopupFrame>
  )
}
export default ModalNotAvailable
